var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccommdation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 49.81,
    viewBox: "0 0 50 49.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(-165 -369.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M165.017,389.368v-.1l24.8-19.81,24.815,19.393-2.39,3.035-1.065-.767V415.13h3.842v3.9h-50v-3.9h3.852V391.174l-1.419,1.118c-.36-.446-.67-.843-.993-1.229C165.982,390.494,165.5,389.933,165.017,389.368Zm7.744,25.748H207.27V414.6q0-13.051.008-26.1a.868.868,0,0,0-.388-.766q-6.392-4.974-12.771-9.966l-4.274-3.336c-.111.084-.2.149-.29.219q-8.2,6.545-16.4,13.083a.975.975,0,0,0-.4.865q.014,12.978.007,25.955Z",
    transform: "translate(-0.015 0)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M165,750.178h50c-.016.065-.022.181-.05.186a1.756,1.756,0,0,1-.34.009q-24.609,0-49.218-.01C165.27,750.363,164.972,750.564,165,750.178Z",
    transform: "translate(0 -331.144)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M255.424,560.613v3.806h-3.852V545.1h3.844v3.861h1.79a5.791,5.791,0,0,1,5.956,5.939c0,.568,0,1.136,0,1.771h15.484v7.743h-3.835v-3.8Zm3.827-3.935c0-.789.048-1.536-.014-2.274a1.7,1.7,0,0,0-1.409-1.5,21.857,21.857,0,0,0-2.363-.019v3.789Z",
    transform: "translate(-75.299 -152.773)",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M310.884,461.439a5.812,5.812,0,1,1,5.632,5.87A5.83,5.83,0,0,1,310.884,461.439Zm5.809-1.856a1.927,1.927,0,1,0,1.943,1.947A1.934,1.934,0,0,0,316.693,459.583Z",
    transform: "translate(-126.888 -75.008)",
    fill: "#fbfbfb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccommdation);
export default __webpack_public_path__ + "static/media/accommdation.e2878c0cb654c621741ea49c28e6af75.svg";
export { ForwardRef as ReactComponent };